import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rcc-header-cell"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c(VBtn,{class:_vm.buttonClasses,attrs:{"icon":"","small":""},on:{"click":_vm.handleSortButtonClick}},[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-arrow-up")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }